<div class="d-flex flex-column justify-content-center align-items-center">
    <div class="process-step-title my-1 text-montserrat">Proceso de Cancelación</div>
    <div class="text-center my-1 text-montserrat">Para solicitar la cancelación de tu póliza vigente se requieren:</div>
    <div class="w-100 text-left">
        <ol class="p-1 text-weight text-montserrat">
            <li>Confirmación del proceso.</li>
            <li>Adjuntar copia o foto del INE por ambos lados</li>
            <li>Tu Firma de autorización</li>
        </ol>
    </div>
    <div class="text-center my-3">El proceso puede llevar hasta 5 días hábiles</div>
</div>